/**
 * The `lang` for text the learner reads or hears: Chinese only when Chinese characters predominate,
 * so a screen reader reads English prompts as English and the browser picks a Chinese font fallback
 * for Hanzi. Returns undefined to inherit the page language.
 */
export function chineseLang(text: string | null | undefined): 'zh' | undefined {
    if (!text) return undefined;
    const han = (text.match(/[㐀-鿿豈-﫿]/g) ?? []).length;
    const latin = (text.match(/[A-Za-z]/g) ?? []).length;
    return han > 0 && han * 2 >= latin ? 'zh' : undefined;
}
